"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconShield = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M56.82 10.35A48.69 48.69 0 0 1 47 8.51a46.59 46.59 0 0 1-9.89-4.13 4.2 4.2 0 0 0-4.16 0A46.62 46.62 0 0 1 23 8.51a48.66 48.66 0 0 1-9.84 1.83 4.21 4.21 0 0 0-3.87 4.19v15.73c0 17.13 9.94 26.65 24.86 35.68a1.6 1.6 0 0 0 1.66 0c14.92-9 24.86-18.55 24.86-35.68V14.54a4.21 4.21 0 0 0-3.85-4.19zm.67 19.91c0 15.38-8.58 23.9-22.48 32.44-13.92-8.54-22.49-17.06-22.49-32.44V14.54a1 1 0 0 1 .91-1 51.89 51.89 0 0 0 10.5-2 49.89 49.89 0 0 0 10.58-4.38 1 1 0 0 1 1 0 49.84 49.84 0 0 0 10.58 4.43 51.91 51.91 0 0 0 10.5 2 1 1 0 0 1 .91 1z"
  }), _react["default"].createElement("path", {
    d: "M50.58 17a34.15 34.15 0 0 1-6.92-1.29 32.76 32.76 0 0 1-6.95-2.9 3.46 3.46 0 0 0-3.42 0 32.71 32.71 0 0 1-6.95 2.9A34.13 34.13 0 0 1 19.42 17a3.46 3.46 0 0 0-3.18 3.45v11.2c0 12.42 7.17 19.3 17.93 25.82a1.6 1.6 0 0 0 1.66 0C46.59 50.93 53.76 44 53.76 31.62v-11.2A3.47 3.47 0 0 0 50.58 17zm0 14.65c0 10.66-5.93 16.62-15.56 22.57-9.63-6-15.56-11.92-15.56-22.57V20.42a.25.25 0 0 1 .22-.25 37.37 37.37 0 0 0 7.58-1.41 36 36 0 0 0 7.64-3.2.25.25 0 0 1 .12 0 .23.23 0 0 1 .12 0 36.08 36.08 0 0 0 7.64 3.2 37.39 37.39 0 0 0 7.58 1.41.25.25 0 0 1 .23.25z"
  })),
  height: undefined,
  width: undefined
});
IconShield.displayName = 'IconShield';
var _default = IconShield;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/shield.js
// module id = 344
// module chunks = 0